<template>

    <div class="ph-item">
        <div class="card overflow-hidden p-3 m-0">
            <div class="grid-container">
                <div class="grid-area-image">
                    <div class="ph-picture"></div>
                </div>
                <div class="grid-area-info">
                    <div class="ph-row mt-3 mt-md-0">
                        <div class="ph-col-4"></div>
                        <div class="ph-col-8 empty"></div>
                    </div>
                    <div class="ph-row mt-3">
                        <div class="ph-col-6 big"></div>
                        <div class="ph-col-6 empty big"></div>
                    </div>
                    <div class="ph-row mt-3">
                        <div class="ph-col-3"></div>
                        <div class="ph-col-9 empty"></div>
                    </div>
                    <div class="ph-row mt-3">
                        <div class="ph-col-2" style="height: 30px"></div>
                        <div class="ph-col-10 empty" style="height: 30px"></div>
                    </div>
                </div>
                <div class="d-none d-sm-block grid-area-price">
                    <div class="price-divider"></div>
                    <div class="d-flex flex-column gap-3 justify-content-center align-items-center h-100">
                        <div class="ph-row">
                            <div class="div" style="height: 20px; width: 100px"></div>
                        </div>
                        <div class="ph-row">
                            <div class="div" style="width: 70px"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "EventEntryLoadingDummy"
}
</script>

<style lang="scss" scoped>
$ph-cols-remove-odd: false !default;
$ph-gutter: 0 !default;
$ph-spacer: 0 !default;
@import "../../../../../node_modules/placeholder-loading/src/scss/placeholder-loading";

.ph-picture {
    height: 100%;
}

.grid-container {
    display: grid;
    gap: map-get($spacers, 4);
    grid-template-columns: 1fr;
    grid-template-rows: 100px auto;
    grid-template-areas:
    "image"
    "info";
}

@include media-breakpoint-up(sm) {
    .grid-container {
        grid-template-columns: 2fr 1fr;
        grid-template-rows: 100px auto;
        grid-template-areas:
            "image image"
            "info price";
    }
}

@include media-breakpoint-up(md) {
    .grid-container {
        grid-template-columns: 1fr 3fr 1fr;
        grid-template-rows: auto;
        grid-template-areas:
            "image info price";
    }

}


.grid-area-image {
    grid-area: image;
    margin: map-get($spacers, -3);

    @include media-breakpoint-up(md) {
        margin-right: 0;
    }
}

.grid-area-info {
    grid-area: info;
}

.grid-area-price {
    grid-area: price;
    position: relative;
}

@include media-breakpoint-up(sm) {
    .price-divider {
        position: absolute;
        top: 0;
        bottom: 0;
        left: map-get($spacers, -4) / 2;
        border-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), $border-color 30%, $border-color 70%, rgba(0, 0, 0, 0)) 1 100%;
        border-left-width: 1px;
        border-left-style: solid;
    }
}


</style>
